// Detect environments safely (avoid referencing undefined global `process` in browser).
// Vitest sets process.env.NODE_ENV === 'test' when executing tests in Node.
// In the browser we rely on Vite's injected import.meta.env.
type EnvRecord = Record<string, string | boolean | undefined>

const nodeEnv: EnvRecord | undefined =
  typeof process !== 'undefined' && process.env
    ? (process.env as EnvRecord)
    : undefined

// Vite always defines import.meta.env (typed via vite/client).
const viteEnv: EnvRecord = import.meta.env as unknown as EnvRecord

const isTestEnv =
  (nodeEnv && nodeEnv.NODE_ENV === 'test') ||
  (viteEnv && viteEnv.MODE === 'test')

const testLoggingEnabled = Boolean(
  (nodeEnv && (nodeEnv.VITE_LOG_TESTS === '1' || nodeEnv.LOG_TESTS === '1')) ||
    (viteEnv && (viteEnv.VITE_LOG_TESTS === '1' || viteEnv.LOG_TESTS === '1'))
)

export function createLog(location: string, useTrace: boolean = false) {
  // In tests return a no-op unless explicitly enabled
  if (isTestEnv && !testLoggingEnabled) {
    return (_: unknown, ...__args: unknown[]) => {
      /* no-op in test env */
    }
  }

  return (...args: unknown[]) => {
    const caller = new Error().stack?.split('\n')[2]?.trim().split(' ')[1]

    // eslint-disable-next-line no-console
    const f = useTrace ? console.trace : console.debug
    f(`%c${location} %c${caller}`, 'color:red', 'color:green', ...args)
  }
}
